module.exports = __webpack_public_path__ + "r-v3/img/coachmark_arrow_blue_01.efeb2c05.svg";